webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(197);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(174);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueResource = __webpack_require__(196);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuelidate = __webpack_require__(200);
	
	var _vuelidate2 = _interopRequireDefault(_vuelidate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.use(_vuelidate2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default },
	  data: function data() {
	    return {
	      BASE:  true ? '' : 'http://localhost:3000'
	    };
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scrollToEl = exports.scrollTo = undefined;
	
	var _typeof2 = __webpack_require__(54);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(53);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(89);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inOutQuintic = function inOutQuintic(t, b, c, d) {
	  var ts = (t /= d) * t,
	      tc = ts * t;
	  return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	};
	
	var requestFrame = function () {
	  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (cb) {
	    return window.setTimeout(cb, 1000 / 60);
	  };
	}();
	
	var getScrollTop = function getScrollTop() {
	  return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
	};
	
	var setScrollTop = function setScrollTop(amount) {
	  document.documentElement.scrollTop = amount;
	  document.body.parentNode.scrollTop = amount;
	  document.body.scrollTop = amount;
	};
	
	var getElementTop = function getElementTop(el) {
	  var top = 0;
	  if (el.offsetParent) {
	    do {
	      top += el.offsetTop;
	    } while (el = el.offsetParent);
	  }
	  return top;
	};
	
	function scrollTo() {
	  var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  opts = (0, _assign2.default)({
	    duration: 500,
	    offset: 0,
	    easing: inOutQuintic
	  }, opts);
	
	  var start = getScrollTop();
	  var change = y + opts.offset - start;
	  var increment = 20;
	
	  var currentTime = 0;
	  var stop = false;
	
	  var promise = new _promise2.default(function (res, rej) {
	
	    (function animateScroll() {
	
	      if (stop) return res(true);
	
	      currentTime += increment;
	      setScrollTop(opts.easing(currentTime, start, change, opts.duration));
	
	      if (currentTime >= opts.duration) return res(false);
	
	      requestFrame(animateScroll);
	    })();
	  });
	
	  promise.stop = function () {
	    return stop = true;
	  };
	
	  return promise;
	}
	
	function scrollToEl(el) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  if (!(el instanceof HTMLElement)) return _promise2.default.reject(new Error("Argument \"el\" should be an instance of HTMLElement, received " + (typeof el === "undefined" ? "undefined" : (0, _typeof3.default)(el))));
	
	  return scrollTo(getElementTop(el), opts);
	}
	
	exports.scrollTo = scrollTo;
	exports.scrollToEl = scrollToEl;

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(99);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(97);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(98);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(52);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _from = __webpack_require__(51);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _set = __webpack_require__(94);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _lodash = __webpack_require__(166);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fastclick = __webpack_require__(165);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	var _BookartCategory = __webpack_require__(175);
	
	var _BookartCategory2 = _interopRequireDefault(_BookartCategory);
	
	var _BookartQuantities = __webpack_require__(180);
	
	var _BookartQuantities2 = _interopRequireDefault(_BookartQuantities);
	
	var _BookartReview = __webpack_require__(181);
	
	var _BookartReview2 = _interopRequireDefault(_BookartReview);
	
	var _BookartSteps = __webpack_require__(182);
	
	var _BookartSteps2 = _interopRequireDefault(_BookartSteps);
	
	var _BookartSubmit = __webpack_require__(183);
	
	var _BookartSubmit2 = _interopRequireDefault(_BookartSubmit);
	
	var _BookartSummary = __webpack_require__(184);
	
	var _BookartSummary2 = _interopRequireDefault(_BookartSummary);
	
	var _scrollToEl = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      categories: [],
	      currentStepIndex: -1,
	      manualStepChange: false,
	      disabledOptions: [],
	      discounts: [],
	      pageprices: [],
	      quantities: {
	        books: 50,
	        pages: 40
	      },
	      selectedOptions: [],
	      steps: ['General', 'Binding & Cover', 'Interior', 'Review', 'Send'],
	      projectInfos: {
	        comments: '',
	        copyediting: '0',
	        deadline: '',
	        designassistance: '0',
	        email: '',
	        firstname: '',
	        lastname: '',
	        postal: '',
	        prepressassistance: '0',
	        publishingsupport: '0'
	      },
	      settings: {}
	    };
	  },
	
	  watch: {
	    currentStepIndex: function currentStepIndex() {
	
	      if (this.manualStepChange) {
	        this.manualStepChange = false;
	      } else {
	        if (this.currentStepIndex === -1) this.currentStepIndex += 1;
	        if (this.currentStepIndex === this.steps.length) this.currentStepIndex -= 1;
	      }
	
	      if (this.currentStepIndex === 4 && this.isTotalInvalid) {
	        this.currentStepIndex -= 1;
	      }
	
	      var stepsTopEl = this.$refs['steps-top'];
	      if (stepsTopEl) (0, _scrollToEl.scrollToEl)(stepsTopEl, { offset: 1 });
	    }
	  },
	
	  computed: {
	    homeTextLines: function homeTextLines() {
	      return this.settings.homeText && this.settings.homeText.split('\n\n');
	    },
	    groups: function groups() {
	      return this.categories.reduce(function (groups, cat, catI) {
	        if (!groups[cat.group]) groups[cat.group] = [];
	        groups[cat.group].push(catI);
	        return groups;
	      }, {});
	    },
	    sections: function sections() {
	      var sections = this.categories.reduce(function (sections, cat, catI) {
	        if (cat.id === 3) return sections;
	        if (!sections[cat.section]) sections[cat.section] = [];
	        sections[cat.section].push(catI);
	        return sections;
	      }, {});
	
	      sections.paper.push(this.categories.findIndex(function (cat) {
	        return cat.id === 3;
	      }));
	      return sections;
	    },
	    isCategoryIndexDisabled: function isCategoryIndexDisabled() {
	      var _this = this;
	
	      return this.categories.map(function (cat) {
	        return cat.options.every(function (opt) {
	          return _this.disabledOptions.includes(opt.id);
	        });
	      });
	    },
	    invalidCategoriesIndexes: function invalidCategoriesIndexes() {
	      var _this2 = this;
	
	      return this.categories.reduce(function (invalidCategoriesIndexes, cat, catI) {
	        var isCategoryDisabled = _this2.isCategoryIndexDisabled[catI];
	        var selectedOptionId = cat.options[_this2.selectedOptions[catI]].id;
	        var isSelectedOptionDisabled = _this2.disabledOptions.includes(selectedOptionId);
	
	        if (!isCategoryDisabled && isSelectedOptionDisabled) {
	          invalidCategoriesIndexes.push(catI);
	        }
	        return invalidCategoriesIndexes;
	      }, []);
	    },
	    isTotalInvalid: function isTotalInvalid() {
	      return this.invalidCategoriesIndexes.length > 0 || this.quantities.books < 50;
	    }
	  },
	
	  methods: {
	    selectOption: function selectOption(catI, optionI) {
	      this.$set(this.selectedOptions, catI, optionI);
	      this.updateDisabledOptions();
	    },
	    submitForm: function submitForm() {
	      if (this.quantities.books < 50) return;
	      this.$refs.submit.submitForm();
	    },
	    success: function success() {
	      this.manualStepChange = true;
	      this.currentStepIndex = 5;
	    },
	    updateDisabledOptions: function updateDisabledOptions() {
	      var disabledOptions = new _set2.default();
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.categories.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              i = _step$value[0],
	              category = _step$value[1];
	
	          var categoryOptionIds = category.options.map(function (cat) {
	            return cat.id;
	          });
	
	          if (categoryOptionIds.every(function (id) {
	            return disabledOptions.has(id);
	          })) {
	            console.log('Category ' + i + ' ' + category.name + ' already has all option disabled. Skipping.');
	            continue;
	          }
	
	          var disabledOptionIds = category.options[this.selectedOptions[i]].disabledOptions;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(disabledOptionIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var id = _step2.value;
	
	              console.log('Category ' + i + ' ' + category.name + ' has disabled option ' + id);
	              disabledOptions.add(id);
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.disabledOptions = (0, _from2.default)(disabledOptions);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var resp, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              _fastclick2.default.attach(document.body);
	
	              _context.prev = 1;
	              _context.next = 4;
	              return _this3.$http.get(_this3.$root.BASE + '/api/v1');
	
	            case 4:
	              resp = _context.sent;
	              data = resp.data.data;
	
	              _this3.categories = data.categories;
	              _this3.discounts = data.discounts;
	              _this3.pageprices = data.pageprices;
	              _this3.settings = data.settings;
	
	              _this3.selectedOptions = _this3.categories.map(function (cat) {
	                return 0;
	              });
	
	              _this3.updateDisabledOptions();
	
	              _context.next = 17;
	              break;
	
	            case 14:
	              _context.prev = 14;
	              _context.t0 = _context['catch'](1);
	
	              console.error('Failed to load API data', _context.t0);
	
	            case 17:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3, [[1, 14]]);
	    }))();
	  },
	
	  components: {
	    BookartCategory: _BookartCategory2.default,
	    BookartQuantities: _BookartQuantities2.default,
	    BookartReview: _BookartReview2.default,
	    BookartSteps: _BookartSteps2.default,
	    BookartSubmit: _BookartSubmit2.default,
	    BookartSummary: _BookartSummary2.default
	  }
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BookartSelect = __webpack_require__(176);
	
	var _BookartSelect2 = _interopRequireDefault(_BookartSelect);
	
	var _BookartToggle = __webpack_require__(177);
	
	var _BookartToggle2 = _interopRequireDefault(_BookartToggle);
	
	var _BookartToggleThumbnail = __webpack_require__(178);
	
	var _BookartToggleThumbnail2 = _interopRequireDefault(_BookartToggleThumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentTypes = ['bookart-toggle', 'bookart-toggle-thumbnail'];
	
	exports.default = {
	  name: 'bookart-category',
	  props: ['value', 'selectedOptionIndex'],
	  data: function data() {
	    return {
	      componentType: componentTypes[this.value.type]
	    };
	  },
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(value) {
	        this.$emit('input', value);
	      }
	    }
	  },
	  components: {
	    BookartSelect: _BookartSelect2.default,
	    BookartToggle: _BookartToggle2.default,
	    BookartToggleThumbnail: _BookartToggleThumbnail2.default
	  }
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tetherSelect = __webpack_require__(86);
	
	var _tetherSelect2 = _interopRequireDefault(_tetherSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bookart-select',
	  props: {
	    value: {
	      required: true
	    }
	  },
	  computed: {
	    model: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(value) {
	        this.$emit('input', value);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var instance = new _tetherSelect2.default({ el: this.$el });
	    instance.on('change', function (e) {
	      return _this.$parent.$emit('select', e.value);
	    });
	  }
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _numeral = __webpack_require__(31);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bookart-toggle',
	  props: ['value', 'selectedOptionIndex'],
	  data: function data() {
	    return {
	      currentOptionIndex: this.selectedOptionIndex
	    };
	  },
	
	  watch: {
	    currentOptionIndex: function currentOptionIndex(optionI) {
	      this.$parent.$emit('select', optionI);
	    }
	  },
	  computed: {
	    selectedOption: function selectedOption() {
	      return this.model.options[this.currentOptionIndex];
	    },
	    disabledOptions: function disabledOptions() {
	      return this.$parent.$parent.disabledOptions;
	    },
	    isCurrentOptionDisabled: function isCurrentOptionDisabled() {
	      return this.disabledOptions.includes(this.selectedOption.id);
	    },
	    areAllOptionsDisabled: function areAllOptionsDisabled() {
	      var _this = this;
	
	      return this.model.options.every(function (option) {
	        return _this.disabledOptions.includes(option.id);
	      });
	    },
	    isCustomFieldEmpty: function isCustomFieldEmpty() {
	      return this.selectedOption.customField && !this.selectedOption.customFieldData;
	    },
	
	    model: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(value) {
	        this.$emit('input', value);
	      }
	    }
	  },
	  methods: {
	    selectOption: function selectOption(option, optI) {
	      if (!this.disabledOptions.includes(option.id)) this.currentOptionIndex = optI;
	    }
	  },
	  filters: {
	    ratio: function ratio(val) {
	      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1×$2');
	    },
	    price: function price(val) {
	      return (0, _numeral2.default)(val).format('$ 0,0.00');
	    }
	  }
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _numeral = __webpack_require__(31);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bookart-toggle-thumbnail',
	
	  props: ['value', 'selectedOptionIndex'],
	
	  data: function data() {
	    var _this = this;
	
	    var thumbnails = this.value.options.map(function (option) {
	      var s3Path = 'https://bucketeer-5f67835c-44c6-4254-99e2-1da74ddb85cf.s3.amazonaws.com/public/';
	
	      return !!option.thumbnail ? 'background-image: url(' + s3Path + _this.value.id + '-' + option.id + '.jpg?' + +new Date() + ')' : null;
	    });
	
	    return {
	      currentOptionIndex: this.selectedOptionIndex,
	      thumbnails: thumbnails
	    };
	  },
	
	
	  watch: {
	    currentOptionIndex: function currentOptionIndex(optionI) {
	      this.$parent.$emit('select', optionI);
	    }
	  },
	
	  computed: {
	    selectedOption: function selectedOption() {
	      return this.model.options[this.currentOptionIndex];
	    },
	    disabledOptions: function disabledOptions() {
	      return this.$parent.$parent.disabledOptions;
	    },
	    isCurrentOptionDisabled: function isCurrentOptionDisabled() {
	      return this.disabledOptions.includes(this.selectedOption.id);
	    },
	    areAllOptionsDisabled: function areAllOptionsDisabled() {
	      var _this2 = this;
	
	      return this.model.options.every(function (option) {
	        return _this2.disabledOptions.includes(option.id);
	      });
	    },
	    isCustomFieldEmpty: function isCustomFieldEmpty() {
	      return this.selectedOption.customField && !this.selectedOption.customFieldData;
	    },
	
	    model: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(value) {
	        this.$emit('input', value);
	      }
	    }
	  },
	  methods: {
	    selectOption: function selectOption(option, optI) {
	      if (!this.disabledOptions.includes(option.id)) this.currentOptionIndex = optI;
	    }
	  },
	  filters: {
	    ratio: function ratio(val) {
	      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1 × $2');
	    },
	    price: function price(val) {
	      return (0, _numeral2.default)(val).format('$ 0,0.00');
	    }
	  }
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'bookart-number',
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    step: {
	      type: Number,
	      default: 1
	    },
	    min: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    }
	  },
	
	  data: function data() {
	    return {
	      internal: this.value
	    };
	  },
	
	
	  computed: {
	    width: function width() {
	      var digits = String(this.internal).replace(/[^0-9]/g, '').length;
	      return Math.max(digits * 10 + 50, 100) + 'px';
	    },
	    isValid: function isValid() {
	      var value = parseInt(this.internal / this.step) * this.step;
	      return value >= this.min && value <= this.max;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.internal = val;
	    },
	    internal: function internal(val) {
	      if (this.isValid) this.$emit('input', this.internal);
	    }
	  },
	
	  methods: {
	    onBlur: function onBlur() {
	      if (!this.isValid) this.internal = this.min;
	    }
	  }
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BookartNumber = __webpack_require__(179);
	
	var _BookartNumber2 = _interopRequireDefault(_BookartNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bookart-quantities',
	  props: ['settings', 'value'],
	  computed: {
	    model: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(value) {
	        this.$emit('input', value);
	      }
	    }
	  },
	  components: {
	    BookartNumber: _BookartNumber2.default
	  }
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _numeral = __webpack_require__(31);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'bookart-review',
	
	  props: ['categories', 'disabledOptions', 'discounts', 'pageprices', 'groups', 'quantities', 'selectedOptions', 'settings', 'stepsGroupsIndexes'],
	
	  data: function data() {
	
	    var currency = this.settings.currency;
	
	    if (this.settings.usdConversionRate != 0) currency = localStorage.currency;
	    return {
	      panelOpened: false,
	      currency: currency
	    };
	  },
	
	
	  filters: {
	    ratio: function ratio(val) {
	      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1 × $2');
	    },
	    price: function price(val) {
	      return (0, _numeral2.default)(val).format('$ 0,0.00');
	    }
	  },
	
	  computed: {
	    showPrices: function showPrices() {
	      return this.settings.showPrices;
	    },
	    exRate: function exRate() {
	
	      if (this.settings.currency == "USD") var exRate = this.settings.usdConversionRate;else var exRate = 1;
	      return exRate;
	    },
	    coverPrice: function coverPrice() {
	      var _this = this;
	
	      return this.groups.cover.reduce(function (coverPrice, catI) {
	        if (_this.isCategoryIndexDisabled[catI]) return coverPrice;
	        return coverPrice + _this.categories[catI].options[_this.selectedOptions[catI]].price;
	      }, 0);
	    },
	    setupFee: function setupFee() {
	      var setupFees = ['Cover Lamination', 'Printing', 'Binding Type'];
	      var i = 0;
	      var setupFee = 0;
	      for (i = 0; i < setupFees.length; i++) {
	        var catI = this.categories.findIndex(function (cat) {
	          return cat.name === setupFees[i];
	        });
	        var option = this.categories[catI].options[this.selectedOptions[catI]];
	        setupFee = setupFee + option.setupFee;
	      }
	      return setupFee;
	    },
	    printPrice: function printPrice() {
	      var _this2 = this;
	
	      var pagepriceRange = this.pageprices.find(function (pageprice) {
	        return _this2.quantities.books * _this2.quantities.pages >= pageprice.min && _this2.quantities.books * _this2.quantities.pages <= pageprice.max;
	      });
	      var catI = 9;
	      var printType = this.selectedOptions[catI];
	      var cat = this.categories;
	      var opt = cat[9].options;
	      var printOpt = opt[printType];
	      var printId = printOpt.id;
	      var price = pagepriceRange.distribution[printId];
	      return price;
	    },
	    pagePrice: function pagePrice() {
	      var _this3 = this;
	
	      var pagePrice = this.groups.page.reduce(function (pagePrice, catI) {
	        var name = _this3.categories[catI].name;
	
	        if (_this3.isCategoryIndexDisabled[catI]) {
	          if (window.DEBUG) console.log('Category ' + name + ' is disabled, skipping.');
	          return pagePrice;
	        } else {
	          var option = _this3.categories[catI].options[_this3.selectedOptions[catI]];
	          if (window.DEBUG) console.log('Category ' + name + ' has option ' + option.name + ' selected. Adding ' + option.price + '$ to total.');
	          return pagePrice + option.price + _this3.printPrice;
	        }
	      }, 0);
	
	      return pagePrice;
	    },
	    bookSizeMultiplier: function bookSizeMultiplier() {
	      var catI = this.groups.multiplier[0];
	      return this.categories[catI].options[this.selectedOptions[catI]].price;
	    },
	    proofingPrice: function proofingPrice() {
	      var catI = this.groups.proofing[0];
	      return this.categories[catI].options[this.selectedOptions[catI]].price;
	    },
	    stampingFlatFee: function stampingFlatFee() {
	      var catI = this.categories.findIndex(function (cat) {
	        return cat.name === 'Stamping';
	      });
	      if (this.categories[catI].options[this.selectedOptions[catI]].price > 0) {
	        return this.settings.stampingFlatFee;
	      } else {
	        return 0;
	      }
	    },
	    stampingPerBookFee: function stampingPerBookFee() {
	      var catI = this.categories.findIndex(function (cat) {
	        return cat.name === 'Stamping';
	      });
	      if (this.categories[catI].options[this.selectedOptions[catI]].price > 0) {
	        return this.settings.stampingPerBookFee * this.categories[catI].options[this.selectedOptions[catI]].price;
	      } else {
	        return 0;
	      }
	    },
	    discountPrice: function discountPrice() {
	      var _this4 = this;
	
	      var discountRange = this.discounts.find(function (discount) {
	        return _this4.quantities.books >= discount.min && _this4.quantities.books <= discount.max;
	      });
	
	      if (!discountRange) return 0;
	
	      var discountPrices = ['cover', 'page', 'proofing'].reduce(function (discountPrices, group) {
	        discountPrices[group] = _this4.groups[group].reduce(function (coverPrice, catI) {
	          if (_this4.isCategoryIndexDisabled[catI]) return coverPrice;
	
	          var cat = _this4.categories[catI];
	          var opt = cat.options[_this4.selectedOptions[catI]];
	          var percentDiscount = discountRange.distribution[cat.id] || 0;
	          var discount = opt.price * percentDiscount * opt.discount / 100;
	
	          return coverPrice + discount;
	        }, 0);
	
	        return discountPrices;
	      }, {});
	
	      var totalDiscount = discountPrices.proofing + this.bookSizeMultiplier * (this.quantities.books * discountPrices.cover + this.quantities.books * this.quantities.pages * discountPrices.page);
	
	      return totalDiscount >= 0 ? totalDiscount : 0;
	    },
	    oneBookPrice: function oneBookPrice() {
	      var flatFeesSplitPerBook = (this.proofingPrice + this.stampingFlatFee + this.setupFee) / this.quantities.books;
	      var perBookFees = this.stampingPerBookFee;
	      var discountPricePerBook = this.discountPrice / this.quantities.books;
	      var coverAndPagePricePerBook = this.coverPrice + this.quantities.pages * this.pagePrice;
	      return (this.bookSizeMultiplier * coverAndPagePricePerBook - discountPricePerBook + flatFeesSplitPerBook + perBookFees) * this.exRate;
	    },
	    preTotalPrice: function preTotalPrice() {
	      return this.proofingPrice + this.stampingFlatFee + this.setupFee + this.stampingPerBookFee * this.quantities.books + this.bookSizeMultiplier * (this.quantities.books * this.coverPrice + this.quantities.books * this.quantities.pages * this.pagePrice);
	    },
	    totalPrice: function totalPrice() {
	      return (this.preTotalPrice - this.discountPrice) * this.exRate;
	    },
	    isCategoryIndexDisabled: function isCategoryIndexDisabled() {
	      var _this5 = this;
	
	      return this.categories.map(function (cat) {
	        return cat.options.every(function (opt) {
	          return _this5.disabledOptions.includes(opt.id);
	        });
	      });
	    },
	    invalidCategoriesIndexes: function invalidCategoriesIndexes() {
	      var _this6 = this;
	
	      return this.categories.reduce(function (invalidCategoriesIndexes, cat, catI) {
	        var isCategoryDisabled = _this6.isCategoryIndexDisabled[catI];
	        var selectedOption = cat.options[_this6.selectedOptions[catI]];
	        var selectedOptionId = selectedOption.id;
	        var isSelectedOptionDisabled = _this6.disabledOptions.includes(selectedOptionId);
	        var isCustomFieldEmpty = selectedOption.customField && !selectedOption.customFieldData;
	
	
	        if (!isCategoryDisabled && isSelectedOptionDisabled || isCustomFieldEmpty) {
	          invalidCategoriesIndexes.push(catI);
	        }
	        return invalidCategoriesIndexes;
	      }, []);
	    },
	    isTotalInvalid: function isTotalInvalid() {
	      return this.invalidCategoriesIndexes.length > 0;
	    },
	    categoriesSummaries: function categoriesSummaries() {
	      var _this7 = this;
	
	      return this.categories.map(function (cat, catI) {
	
	        var option = cat.options[_this7.selectedOptions[catI]];
	
	        return {
	          category: cat.name,
	          name: option.customField ? option.customFieldData + ' (Custom)' : option.name,
	          price: option.price
	        };
	      });
	    }
	  }
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'bookart-steps',
	
	  props: {
	    disabledOptions: Array,
	    steps: Array,
	    value: Number
	  },
	
	  data: function data() {
	    return {
	      isFixed: false,
	      stickyContainerHeight: 0
	    };
	  },
	
	  computed: {
	    currentStepIndex: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(val) {
	        this.$emit('input', val);
	      }
	    }
	  },
	
	  methods: {
	    updateStickyPosition: function updateStickyPosition() {
	      this.isFixed = window.scrollY >= this.$refs.placeholder.offsetTop;
	    },
	    updateValues: function updateValues() {
	      this.stickyContainerHeight = this.$refs.nav.offsetHeight;
	    },
	    submitForm: function submitForm() {
	      this.$parent.$refs.submit.submitForm();
	    }
	  },
	
	  mounted: function mounted() {
	    window.addEventListener('resize', this.updateValues);
	    window.addEventListener('scroll', this.updateStickyPosition);
	    this.updateValues();
	    this.updateStickyPosition();
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.updateValues);
	    window.removeEventListener('scroll', this.updateStickyPosition);
	  }
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(88);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _from = __webpack_require__(51);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _validators = __webpack_require__(206);
	
	var _vuejsDatepicker = __webpack_require__(199);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	var _scrollToEl = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'bookart-submit',
	
	  props: ['value', 'settings'],
	
	  components: {
	    'datepicker': _vuejsDatepicker2.default
	  },
	
	  data: function data() {
	    return {
	      designFiles: [],
	      disabledDates: { to: new Date(Date.now()) },
	      HTMLSummary: ''
	    };
	  },
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(value) {
	        this.$emit('input', value);
	      }
	    }
	  },
	
	  methods: {
	    filePickerChange: function filePickerChange(e) {
	      var files = (0, _from2.default)(e.target.files);
	      var size = files.reduce(function (size, file) {
	        return size += file.size;
	      }, 0);
	
	      if (size > 24 * 1024 * 1024) {
	        alert('You can only upload a maximum of 24MB of attached files.');
	        e.target.value = null;
	      } else {
	        this.designFiles = files.map(function (f) {
	          return {
	            filename: f.name,
	            size: (size / 1024 / 1024).toFixed(2) + 'MB'
	          };
	        });
	      }
	    },
	    openFilePicker: function openFilePicker() {
	      this.$refs.filePicker.click();
	    },
	    submitForm: function submitForm(e) {
	      var _this = this;
	
	      if (this.$v.$invalid) {
	        this.$v.model.firstname.$touch();
	        this.$v.model.lastname.$touch();
	        this.$v.model.email.$touch();
	        (0, _scrollToEl.scrollToEl)(this.$refs.form);
	        return false;
	      }
	
	      var formData = new FormData(this.$refs.form);
	
	      this.$http.post(this.$root.BASE + '/api/v1/submit', formData, {
	        headers: { 'Content-Type': 'multipart/form-data' }
	      }).then(function (response) {
	        _this.$emit('success');
	      }).catch(function (err) {
	        console.error(err);
	        alert('Sorry, there\'s been an error on our end :(');
	      });
	
	      return false;
	    }
	  },
	
	  validations: {
	    model: {
	      firstname: { required: _validators.required },
	      lastname: { required: _validators.required },
	      email: { required: _validators.required, email: _validators.email }
	    }
	  },
	
	  mounted: function mounted() {
	    var el = document.querySelector('section.SummaryPanel');
	    if (el) this.HTMLSummary = (0, _stringify2.default)(el.innerHTML);
	  }
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _numeral = __webpack_require__(31);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'bookart-summary',
	
	  props: ['categories', 'disabledOptions', 'discounts', 'pageprices', 'groups', 'quantities', 'selectedOptions', 'settings'],
	
	  data: function data() {
	    var currency = 'USD';
	    if (localStorage.currency == undefined || localStorage.currency == '') {
	      currency = 'USD';
	    } else {
	      currency = localStorage.currency;
	    }
	
	    this.settings.currency = currency;
	
	    localStorage.currency = currency;
	
	    if (this.settings.usdConversionRate != 0) currency = localStorage.currency;
	    return {
	      panelOpened: false,
	      currency: currency
	    };
	  },
	
	
	  filters: {
	    ratio: function ratio(val) {
	      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1 × $2');
	    },
	    price: function price(val) {
	      return (0, _numeral2.default)(val).format('$ 0,0.00');
	    }
	  },
	
	  computed: {
	    showPrices: function showPrices() {
	      return this.settings.showPrices;
	    },
	    exRate: function exRate() {
	      if (this.currency == 'USD') var exRate = this.settings.usdConversionRate;else var exRate = 1;
	
	      return exRate;
	    },
	    coverPrice: function coverPrice() {
	      var _this = this;
	
	      if (window.DEBUG) {
	        console.groupCollapsed('Cover price');
	      }
	
	      var coverPrice = this.groups.cover.reduce(function (coverPrice, catI) {
	        var name = _this.categories[catI].name;
	
	        if (_this.isCategoryIndexDisabled[catI]) {
	          if (window.DEBUG) console.log('Category ' + name + ' is disabled, skipping.');
	          return coverPrice;
	        } else {
	          var option = _this.categories[catI].options[_this.selectedOptions[catI]];
	          if (window.DEBUG) console.log('Category ' + name + ' has option ' + option.name + ' selected. Adding ' + option.price + '$ to total.');
	          return coverPrice + option.price;
	        }
	      }, 0);
	
	      if (window.DEBUG) {
	        console.log('Total cover price: ' + coverPrice + '$');
	        console.groupEnd('Cover price');
	      }
	
	      return coverPrice;
	    },
	    setupFee: function setupFee() {
	      var setupFees = ['Cover Lamination', 'Printing', 'Binding Type'];
	      var i = 0;
	      var setupFee = 0;
	      for (i = 0; i < setupFees.length; i++) {
	        var catI = this.categories.findIndex(function (cat) {
	          return cat.name === setupFees[i];
	        });
	        var option = this.categories[catI].options[this.selectedOptions[catI]];
	        setupFee = setupFee + option.setupFee;
	      }
	      return setupFee;
	    },
	    printPrice: function printPrice() {
	      var _this2 = this;
	
	      var pagepriceRange = this.pageprices.find(function (pageprice) {
	        return _this2.quantities.books * _this2.quantities.pages >= pageprice.min && _this2.quantities.books * _this2.quantities.pages <= pageprice.max;
	      });
	      var catI = 9;
	      var printType = this.selectedOptions[catI];
	      var cat = this.categories;
	      var opt = cat[9].options;
	      var printOpt = opt[printType];
	      var printId = printOpt.id;
	      var price = pagepriceRange.distribution[printId];
	      return price;
	    },
	    pagePrice: function pagePrice() {
	      var _this3 = this;
	
	      if (window.DEBUG) {
	        console.groupCollapsed('Page price');
	      }
	
	      var pagePrice = this.groups.page.reduce(function (pagePrice, catI) {
	        var name = _this3.categories[catI].name;
	
	        if (_this3.isCategoryIndexDisabled[catI]) {
	          if (window.DEBUG) console.log('Category ' + name + ' is disabled, skipping.');
	          return pagePrice;
	        } else {
	          var option = _this3.categories[catI].options[_this3.selectedOptions[catI]];
	          if (window.DEBUG) console.log('Category ' + name + ' has option ' + option.name + ' selected. Adding ' + option.price + '$ to total.');
	          return pagePrice + option.price + _this3.printPrice;
	        }
	      }, 0);
	
	      if (window.DEBUG) {
	        console.log('Total page price: ' + pagePrice + '$');
	        console.groupEnd('Page price');
	      }
	
	      return pagePrice;
	    },
	    bookSizeMultiplier: function bookSizeMultiplier() {
	      var catI = this.groups.multiplier[0];
	      return this.categories[catI].options[this.selectedOptions[catI]].price;
	    },
	    proofingPrice: function proofingPrice() {
	      var catI = this.groups.proofing[0];
	      return this.categories[catI].options[this.selectedOptions[catI]].price;
	    },
	    stampingFlatFee: function stampingFlatFee() {
	      var catI = this.categories.findIndex(function (cat) {
	        return cat.name === 'Stamping';
	      });
	      if (this.categories[catI].options[this.selectedOptions[catI]].price > 0) {
	        return this.settings.stampingFlatFee;
	      } else {
	        return 0;
	      }
	    },
	    stampingPerBookFee: function stampingPerBookFee() {
	      var catI = this.categories.findIndex(function (cat) {
	        return cat.name === 'Stamping';
	      });
	      if (this.categories[catI].options[this.selectedOptions[catI]].price > 0) {
	        return this.settings.stampingPerBookFee * this.categories[catI].options[this.selectedOptions[catI]].price;
	      } else {
	        return 0;
	      }
	    },
	    discountPrice: function discountPrice() {
	      var _this4 = this;
	
	      var discountRange = this.discounts.find(function (discount) {
	        return _this4.quantities.books >= discount.min && _this4.quantities.books <= discount.max;
	      });
	
	      if (!discountRange) return 0;
	
	      if (window.DEBUG) {
	        console.groupCollapsed('Discount');
	        console.log('Book quantity matched discount range [' + discountRange.min + '..' + discountRange.max + ']');
	      }
	
	      var discountPrices = ['cover', 'page', 'proofing'].reduce(function (discountPrices, group) {
	        discountPrices[group] = _this4.groups[group].reduce(function (coverPrice, catI) {
	          if (_this4.isCategoryIndexDisabled[catI]) return coverPrice;
	
	          var cat = _this4.categories[catI];
	          var opt = cat.options[_this4.selectedOptions[catI]];
	          var percentDiscount = discountRange.distribution[cat.id] || 0;
	          var discount = opt.price * percentDiscount * opt.discount / 100;
	
	          if (window.DEBUG && discount > 0) {
	            console.log('Applying ' + percentDiscount + '% discount on ' + cat.name + '\'s selected option "' + opt.name + '"\'s price ' + opt.price.toFixed(2) + '$ for a total of ' + discount.toFixed(2) + '$ discount');
	          }
	
	          if (Math.pow(window.DEBUG, percentDiscount) < 0) {
	            console.error('ERROR: USING NEGATIVE PERCENTAGES PRODUCES WRONG RESULTS');
	          }
	
	          return coverPrice + discount;
	        }, 0);
	
	        if (window.DEBUG) {
	          console.log('Discount for ' + group + ' price is ' + discountPrices[group].toFixed(2) + '$');
	        }
	
	        return discountPrices;
	      }, {});
	
	      var totalDiscount = discountPrices.proofing + this.bookSizeMultiplier * (this.quantities.books * discountPrices.cover + this.quantities.books * this.quantities.pages * discountPrices.page);
	
	      if (window.DEBUG) {
	        console.log('Applying discount formula');
	        console.log('Discount for Proofing price: ' + discountPrices.proofing.toFixed(2) + '$ +\n        Book Size Multiplier: ' + this.bookSizeMultiplier + ' \xD7 (\n          (Book Quantity: ' + this.quantities.books + ' \xD7 Discount for Cover Price: ' + discountPrices.cover.toFixed(2) + '$) +\n          (Book Quantity: ' + this.quantities.books + ' \xD7 Page Quantity: ' + this.quantities.pages + ' \xD7 Discount for Page Price: ' + discountPrices.page.toFixed(2) + '$)\n        )');
	        console.log('Total discount: ' + totalDiscount.toFixed(2) + '$');
	        console.groupEnd();
	      }
	
	      return totalDiscount >= 0 ? totalDiscount : 0;
	    },
	    oneBookPrice: function oneBookPrice() {
	      var flatFeesSplitPerBook = (this.proofingPrice + this.stampingFlatFee + this.setupFee) / this.quantities.books;
	      var perBookFees = this.stampingPerBookFee;
	      var discountPricePerBook = this.discountPrice / this.quantities.books;
	      var coverAndPagePricePerBook = this.coverPrice + this.quantities.pages * this.pagePrice;
	      return (this.bookSizeMultiplier * coverAndPagePricePerBook - discountPricePerBook + flatFeesSplitPerBook + perBookFees) * this.exRate;
	    },
	    preTotalPrice: function preTotalPrice() {
	      return this.proofingPrice + this.stampingFlatFee + this.setupFee + this.stampingPerBookFee * this.quantities.books + this.bookSizeMultiplier * (this.quantities.books * this.coverPrice + this.quantities.books * this.quantities.pages * this.pagePrice);
	    },
	    totalPrice: function totalPrice() {
	      return (this.preTotalPrice - this.discountPrice) * this.exRate;
	    },
	    isCategoryIndexDisabled: function isCategoryIndexDisabled() {
	      var _this5 = this;
	
	      return this.categories.map(function (cat) {
	        return cat.options.every(function (opt) {
	          return _this5.disabledOptions.includes(opt.id);
	        });
	      });
	    },
	    invalidCategoriesIndexes: function invalidCategoriesIndexes() {
	      var _this6 = this;
	
	      return this.categories.reduce(function (invalidCategoriesIndexes, cat, catI) {
	        var isCategoryDisabled = _this6.isCategoryIndexDisabled[catI];
	        var selectedOptionId = cat.options[_this6.selectedOptions[catI]].id;
	        var isSelectedOptionDisabled = _this6.disabledOptions.includes(selectedOptionId);
	
	        if (!isCategoryDisabled && isSelectedOptionDisabled) {
	          invalidCategoriesIndexes.push(catI);
	        }
	        return invalidCategoriesIndexes;
	      }, []);
	    },
	    isTotalInvalid: function isTotalInvalid() {
	      return this.invalidCategoriesIndexes.length > 0;
	    },
	    categoriesSummaries: function categoriesSummaries() {
	      var _this7 = this;
	
	      return this.categories.map(function (cat, catI) {
	        var option = cat.options[_this7.selectedOptions[catI]];
	
	        return {
	          category: cat.name,
	          name: option.customField ? option.customFieldData + ' (Custom)' : option.name,
	          price: option.price
	        };
	      });
	    }
	  },
	
	  methods: {
	    closeOnOutsideClick: function closeOnOutsideClick(e) {
	      if (this.$refs.button.contains(e.target)) return;
	      if (this.$refs.panel.contains(e.target)) return;
	
	      this.closePanel();
	    },
	    closePanel: function closePanel() {
	      this.panelOpened = false;
	      document.removeEventListener('click', this.closeOnOutsideClick);
	    },
	    openPanel: function openPanel() {
	      this.panelOpened = true;
	      document.addEventListener('click', this.closeOnOutsideClick);
	    },
	    togglePanel: function togglePanel() {
	      this[this.panelOpened ? 'closePanel' : 'openPanel']();
	    },
	    toggleCurrency: function toggleCurrency(currency) {
	      this.currency = currency;
	      localStorage.currency = currency;
	      this.settings.currency = currency;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('click', this.closeOnOutsideClick);
	  }
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _create = __webpack_require__(90);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _getPrototypeOf = __webpack_require__(93);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(92);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty = __webpack_require__(91);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _typeof2 = __webpack_require__(54);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(171)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	    module.exports = factory(require('tether'));
	  } else {
	    root.Select = factory(root.Tether);
	  }
	})(undefined, function (Tether) {
	
	  'use strict';
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;(0, _defineProperty2.default)(target, descriptor.key, descriptor);
	      }
	    }return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	  }();
	
	  var _get = function get(_x3, _x4, _x5) {
	    var _again = true;_function: while (_again) {
	      var object = _x3,
	          property = _x4,
	          receiver = _x5;desc = parent = getter = undefined;_again = false;var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);if (desc === undefined) {
	        var parent = (0, _getPrototypeOf2.default)(object);if (parent === null) {
	          return undefined;
	        } else {
	          _x3 = parent;_x4 = property;_x5 = receiver;_again = true;continue _function;
	        }
	      } else if ('value' in desc) {
	        return desc.value;
	      } else {
	        var getter = desc.get;if (getter === undefined) {
	          return undefined;
	        }return getter.call(receiver);
	      }
	    }
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError('Cannot call a class as a function');
	    }
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== 'function' && superClass !== null) {
	      throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	    }subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) subClass.__proto__ = superClass;
	  }
	
	  var _Tether$Utils = Tether.Utils;
	  var extend = _Tether$Utils.extend;
	  var addClass = _Tether$Utils.addClass;
	  var removeClass = _Tether$Utils.removeClass;
	  var hasClass = _Tether$Utils.hasClass;
	  var getBounds = _Tether$Utils.getBounds;
	  var Evented = _Tether$Utils.Evented;
	
	  var ENTER = 13;
	  var ESCAPE = 27;
	  var SPACE = 32;
	  var UP = 38;
	  var DOWN = 40;
	
	  var touchDevice = 'ontouchstart' in document.documentElement;
	  var clickEvent = touchDevice ? 'touchstart' : 'click';
	
	  function _useNative() {
	    var innerWidth = window.innerWidth;
	    var innerHeight = window.innerHeight;
	
	    return touchDevice && (innerWidth <= 640 || innerHeight <= 640);
	  }
	
	  function isRepeatedChar(str) {
	    return Array.prototype.reduce.call(str, function (a, b) {
	      return a === b ? b : false;
	    });
	  }
	
	  function getFocusedSelect() {
	    var focusedTarget = document.querySelector('.select-target-focused');
	    return focusedTarget ? focusedTarget.selectInstance : null;
	  }
	
	  var searchText = '';
	  var searchTextTimeout = undefined;
	
	  document.addEventListener('keypress', function (e) {
	    var select = getFocusedSelect();
	    if (!select || e.charCode === 0) {
	      return;
	    }
	
	    if (e.keyCode === SPACE) {
	      e.preventDefault();
	    }
	
	    clearTimeout(searchTextTimeout);
	    searchTextTimeout = setTimeout(function () {
	      searchText = '';
	    }, 500);
	
	    searchText += String.fromCharCode(e.charCode);
	
	    var options = select.findOptionsByPrefix(searchText);
	
	    if (options.length === 1) {
	      select.selectOption(options[0]);
	    }
	
	    if (searchText.length > 1 && isRepeatedChar(searchText)) {
	      var repeatedOptions = select.findOptionsByPrefix(searchText[0]);
	
	      if (repeatedOptions.length) {
	        var selected = repeatedOptions.indexOf(select.getChosen());
	
	        selected += 1;
	        selected = selected % repeatedOptions.length;
	
	        select.selectOption(repeatedOptions[selected]);
	        return;
	      }
	    }
	
	    if (options.length) {
	      select.selectOption(options[0]);
	      return;
	    }
	  });
	
	  document.addEventListener('keydown', function (e) {
	    var select = getFocusedSelect();
	    if (!select) {
	      return;
	    }
	
	    if ([UP, DOWN, ESCAPE].indexOf(e.keyCode) >= 0) {
	      e.preventDefault();
	    }
	
	    if (select.isOpen()) {
	      switch (e.keyCode) {
	        case UP:
	        case DOWN:
	          select.moveHighlight(e.keyCode);
	          break;
	        case ENTER:
	          select.selectHighlightedOption();
	          break;
	        case ESCAPE:
	          select.close();
	          select.target.focus();
	      }
	    } else {
	      if ([UP, DOWN, SPACE].indexOf(e.keyCode) >= 0) {
	        select.open();
	      }
	    }
	  });
	
	  var Select = function (_Evented) {
	    function Select(options) {
	      _classCallCheck(this, Select);
	
	      _get((0, _getPrototypeOf2.default)(Select.prototype), 'constructor', this).call(this, options);
	      this.options = extend({}, Select.defaults, options);
	      this.select = this.options.el;
	
	      if (typeof this.select.selectInstance !== 'undefined') {
	        throw new Error('This element has already been turned into a Select');
	      }
	
	      this.update = this.update.bind(this);
	
	      this.setupTarget();
	      this.renderTarget();
	
	      this.setupDrop();
	      this.renderDrop();
	
	      this.setupSelect();
	
	      this.setupTether();
	      this.bindClick();
	
	      this.bindMutationEvents();
	
	      this.value = this.select.value;
	    }
	
	    _inherits(Select, _Evented);
	
	    _createClass(Select, [{
	      key: 'useNative',
	      value: function useNative() {
	        var native = this.options.useNative;
	        return native === true || _useNative() && native !== false;
	      }
	    }, {
	      key: 'setupTarget',
	      value: function setupTarget() {
	        var _this = this;
	
	        this.target = document.createElement('a');
	        this.target.href = 'javascript:;';
	
	        addClass(this.target, 'select-target');
	
	        var tabIndex = this.select.getAttribute('tabindex') || 0;
	        this.target.setAttribute('tabindex', tabIndex);
	
	        if (this.options.className) {
	          addClass(this.target, this.options.className);
	        }
	
	        this.target.selectInstance = this;
	
	        this.target.addEventListener('click', function () {
	          if (!_this.isOpen()) {
	            _this.target.focus();
	          } else {
	            _this.target.blur();
	          }
	        });
	
	        this.target.addEventListener('focus', function () {
	          addClass(_this.target, 'select-target-focused');
	        });
	
	        this.target.addEventListener('blur', function (_ref) {
	          var relatedTarget = _ref.relatedTarget;
	
	          if (_this.isOpen()) {
	            if (relatedTarget && !_this.drop.contains(relatedTarget)) {
	              _this.close();
	            }
	          }
	
	          removeClass(_this.target, 'select-target-focused');
	        });
	
	        this.select.parentNode.insertBefore(this.target, this.select.nextSibling);
	      }
	    }, {
	      key: 'setupDrop',
	      value: function setupDrop() {
	        var _this2 = this;
	
	        this.drop = document.createElement('div');
	        addClass(this.drop, 'select');
	
	        if (this.options.className) {
	          addClass(this.drop, this.options.className);
	        }
	
	        document.body.appendChild(this.drop);
	
	        this.drop.addEventListener('click', function (e) {
	          if (hasClass(e.target, 'select-option')) {
	            _this2.pickOption(e.target);
	          }
	
	          e.stopPropagation();
	        });
	
	        this.drop.addEventListener('mousemove', function (e) {
	          if (hasClass(e.target, 'select-option')) {
	            _this2.highlightOption(e.target);
	          }
	        });
	
	        this.content = document.createElement('div');
	        addClass(this.content, 'select-content');
	        this.drop.appendChild(this.content);
	      }
	    }, {
	      key: 'open',
	      value: function open() {
	        var _this3 = this;
	
	        addClass(this.target, 'select-open');
	
	        if (this.useNative()) {
	          this.select.style.display = 'block';
	
	          setTimeout(function () {
	            var event = document.createEvent('MouseEvents');
	            event.initEvent('mousedown', true, true);
	            _this3.select.dispatchEvent(event);
	          });
	
	          return;
	        }
	
	        addClass(this.drop, 'select-open');
	
	        setTimeout(function () {
	          _this3.tether.enable();
	        });
	
	        var selectedOption = this.drop.querySelector('.select-option-selected');
	
	        if (!selectedOption) {
	          return;
	        }
	
	        this.highlightOption(selectedOption);
	        this.scrollDropContentToOption(selectedOption);
	
	        var positionSelectStyle = function positionSelectStyle() {
	          if (hasClass(_this3.drop, 'tether-abutted-left') || hasClass(_this3.drop, 'tether-abutted-bottom')) {
	            var dropBounds = getBounds(_this3.drop);
	            var optionBounds = getBounds(selectedOption);
	
	            var offset = dropBounds.top - (optionBounds.top + optionBounds.height);
	
	            _this3.drop.style.top = '' + ((parseFloat(_this3.drop.style.top) || 0) + offset) + 'px';
	          }
	        };
	
	        var alignToHighlighted = this.options.alignToHighlighted;
	        var _content = this.content;
	        var scrollHeight = _content.scrollHeight;
	        var clientHeight = _content.clientHeight;
	
	        if (alignToHighlighted === 'always' || alignToHighlighted === 'auto' && scrollHeight <= clientHeight) {
	          setTimeout(function () {
	            positionSelectStyle();
	          });
	        }
	
	        this.trigger('open');
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        removeClass(this.target, 'select-open');
	
	        if (this.useNative()) {
	          this.select.style.display = 'none';
	          return;
	        }
	
	        this.tether.disable();
	
	        removeClass(this.drop, 'select-open');
	
	        this.trigger('close');
	      }
	    }, {
	      key: 'toggle',
	      value: function toggle() {
	        if (this.isOpen()) {
	          this.close();
	        } else {
	          this.open();
	        }
	      }
	    }, {
	      key: 'isOpen',
	      value: function isOpen() {
	        return hasClass(this.drop, 'select-open');
	      }
	    }, {
	      key: 'bindClick',
	      value: function bindClick() {
	        var _this4 = this;
	
	        this.target.addEventListener(clickEvent, function (e) {
	          e.preventDefault();
	          _this4.toggle();
	        });
	
	        document.addEventListener(clickEvent, function (event) {
	          if (!_this4.isOpen()) {
	            return;
	          }
	
	          if (event.target === _this4.drop || _this4.drop.contains(event.target)) {
	            return;
	          }
	
	          if (event.target === _this4.target || _this4.target.contains(event.target)) {
	            return;
	          }
	
	          _this4.close();
	        });
	      }
	    }, {
	      key: 'setupTether',
	      value: function setupTether() {
	        this.tether = new Tether(extend({
	          element: this.drop,
	          target: this.target,
	          attachment: 'top left',
	          targetAttachment: 'bottom left',
	          classPrefix: 'select',
	          constraints: [{
	            to: 'window',
	            attachment: 'together'
	          }]
	        }, this.options.tetherOptions));
	      }
	    }, {
	      key: 'renderTarget',
	      value: function renderTarget() {
	        this.target.innerHTML = '';
	
	        var options = this.select.querySelectorAll('option');
	        for (var i = 0; i < options.length; ++i) {
	          var option = options[i];
	          if (option.selected) {
	            this.target.innerHTML = option.innerHTML;
	            break;
	          }
	        }
	
	        this.target.appendChild(document.createElement('b'));
	      }
	    }, {
	      key: 'renderDrop',
	      value: function renderDrop() {
	        var optionList = document.createElement('ul');
	        addClass(optionList, 'select-options');
	
	        var options = this.select.querySelectorAll('option');
	        for (var i = 0; i < options.length; ++i) {
	          var el = options[i];
	          var option = document.createElement('li');
	          addClass(option, 'select-option');
	
	          option.setAttribute('data-value', el.value);
	          option.innerHTML = el.innerHTML;
	
	          if (el.selected) {
	            addClass(option, 'select-option-selected');
	          }
	
	          optionList.appendChild(option);
	        }
	
	        this.content.innerHTML = '';
	        this.content.appendChild(optionList);
	      }
	    }, {
	      key: 'update',
	      value: function update() {
	        this.renderDrop();
	        this.renderTarget();
	      }
	    }, {
	      key: 'setupSelect',
	      value: function setupSelect() {
	        this.select.selectInstance = this;
	
	        addClass(this.select, 'select-select');
	
	        this.select.addEventListener('change', this.update);
	      }
	    }, {
	      key: 'bindMutationEvents',
	      value: function bindMutationEvents() {
	        if (typeof window.MutationObserver !== 'undefined') {
	          this.observer = new MutationObserver(this.update);
	          this.observer.observe(this.select, {
	            childList: true,
	            attributes: true,
	            characterData: true,
	            subtree: true
	          });
	        } else {
	          this.select.addEventListener('DOMSubtreeModified', this.update);
	        }
	      }
	    }, {
	      key: 'findOptionsByPrefix',
	      value: function findOptionsByPrefix(text) {
	        var options = this.drop.querySelectorAll('.select-option');
	
	        text = text.toLowerCase();
	
	        return Array.prototype.filter.call(options, function (option) {
	          return option.innerHTML.toLowerCase().substr(0, text.length) === text;
	        });
	      }
	    }, {
	      key: 'findOptionsByValue',
	      value: function findOptionsByValue(val) {
	        var options = this.drop.querySelectorAll('.select-option');
	
	        return Array.prototype.filter.call(options, function (option) {
	          return option.getAttribute('data-value') === val;
	        });
	      }
	    }, {
	      key: 'getChosen',
	      value: function getChosen() {
	        if (this.isOpen()) {
	          return this.drop.querySelector('.select-option-highlight');
	        }
	        return this.drop.querySelector('.select-option-selected');
	      }
	    }, {
	      key: 'selectOption',
	      value: function selectOption(option) {
	        if (this.isOpen()) {
	          this.highlightOption(option);
	          this.scrollDropContentToOption(option);
	        } else {
	          this.pickOption(option, false);
	        }
	      }
	    }, {
	      key: 'resetSelection',
	      value: function resetSelection() {
	        this.selectOption(this.drop.querySelector('.select-option'));
	      }
	    }, {
	      key: 'highlightOption',
	      value: function highlightOption(option) {
	        var highlighted = this.drop.querySelector('.select-option-highlight');
	        if (highlighted) {
	          removeClass(highlighted, 'select-option-highlight');
	        }
	
	        addClass(option, 'select-option-highlight');
	
	        this.trigger('highlight', { option: option });
	      }
	    }, {
	      key: 'moveHighlight',
	      value: function moveHighlight(directionKeyCode) {
	        var highlighted = this.drop.querySelector('.select-option-highlight');
	        if (!highlighted) {
	          this.highlightOption(this.drop.querySelector('.select-option'));
	          return;
	        }
	
	        var options = this.drop.querySelectorAll('.select-option');
	
	        var highlightedIndex = Array.prototype.indexOf.call(options, highlighted);
	        if (!(highlightedIndex >= 0)) {
	          return;
	        }
	
	        if (directionKeyCode === UP) {
	          highlightedIndex -= 1;
	        } else {
	          highlightedIndex += 1;
	        }
	
	        if (highlightedIndex < 0 || highlightedIndex >= options.length) {
	          return;
	        }
	
	        var newHighlight = options[highlightedIndex];
	
	        this.highlightOption(newHighlight);
	        this.scrollDropContentToOption(newHighlight);
	      }
	    }, {
	      key: 'scrollDropContentToOption',
	      value: function scrollDropContentToOption(option) {
	        var _content2 = this.content;
	        var scrollHeight = _content2.scrollHeight;
	        var clientHeight = _content2.clientHeight;
	        var scrollTop = _content2.scrollTop;
	
	        if (scrollHeight > clientHeight) {
	          var contentBounds = getBounds(this.content);
	          var optionBounds = getBounds(option);
	
	          this.content.scrollTop = optionBounds.top - (contentBounds.top - scrollTop);
	        }
	      }
	    }, {
	      key: 'selectHighlightedOption',
	      value: function selectHighlightedOption() {
	        this.pickOption(this.drop.querySelector('.select-option-highlight'));
	      }
	    }, {
	      key: 'pickOption',
	      value: function pickOption(option) {
	        var _this5 = this;
	
	        var close = arguments[1] === undefined ? true : arguments[1];
	
	        this.value = this.select.value = option.getAttribute('data-value');
	        this.triggerChange();
	
	        if (close) {
	          setTimeout(function () {
	            _this5.close();
	            _this5.target.focus();
	          });
	        }
	      }
	    }, {
	      key: 'triggerChange',
	      value: function triggerChange() {
	        var event = document.createEvent('HTMLEvents');
	        event.initEvent('change', true, false);
	        this.select.dispatchEvent(event);
	
	        this.trigger('change', { value: this.select.value });
	      }
	    }, {
	      key: 'change',
	      value: function change(val) {
	        var options = this.findOptionsByValue(val);
	
	        if (!options.length) {
	          throw new Error('Select Error: An option with the value "' + val + '" doesn\'t exist');
	        }
	
	        this.pickOption(options[0], false);
	      }
	    }]);
	
	    return Select;
	  }(Evented);
	
	  Select.defaults = {
	    alignToHighlighed: 'auto',
	    className: 'select-theme-default'
	  };
	
	  Select.init = function () {
	    var options = arguments[0] === undefined ? {} : arguments[0];
	
	    if (document.readyState === 'loading') {
	      document.addEventListener('DOMContentLoaded', function () {
	        return Select.init(options);
	      });
	      return;
	    }
	
	    if (typeof options.selector === 'undefined') {
	      options.selector = 'select';
	    }
	
	    var selectors = document.querySelectorAll(options.selector);
	    for (var i = 0; i < selectors.length; ++i) {
	      var el = selectors[i];
	      if (!el.selectInstance) {
	        new Select(extend({ el: el }, options));
	      }
	    }
	  };
	  return Select;
	});

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.17bec08.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(159)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(75),
	  /* template */
	  __webpack_require__(190),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(160)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(76),
	  /* template */
	  __webpack_require__(191),
	  /* scopeId */
	  "data-v-675f1059",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(154)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(77),
	  /* template */
	  __webpack_require__(185),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(163)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(78),
	  /* template */
	  __webpack_require__(194),
	  /* scopeId */
	  "data-v-c03a90e4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(155)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(79),
	  /* template */
	  __webpack_require__(186),
	  /* scopeId */
	  "data-v-2206a320",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(162)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(80),
	  /* template */
	  __webpack_require__(193),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(157)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(81),
	  /* template */
	  __webpack_require__(188),
	  /* scopeId */
	  "data-v-44cfb82f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(161)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(82),
	  /* template */
	  __webpack_require__(192),
	  /* scopeId */
	  "data-v-74ebb0cd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(158)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(83),
	  /* template */
	  __webpack_require__(189),
	  /* scopeId */
	  "data-v-57eb3ef2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(156)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(84),
	  /* template */
	  __webpack_require__(187),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(164)
	
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(85),
	  /* template */
	  __webpack_require__(195),
	  /* scopeId */
	  "data-v-fb070bb2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    staticClass: "BookartSelect"
	  }, _vm._l((_vm.model.options), function(option, optI) {
	    return _c('option', {
	      domProps: {
	        "value": optI
	      }
	    }, [_vm._v(_vm._s(option.name))])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "ToggleThumbnailGroup nl1-ns nr1-ns"
	  }, _vm._l((_vm.model.options), function(option, optI) {
	    return (!_vm.disabledOptions.includes(option.id)) ? _c('div', {
	      staticClass: "ToggleThumbnail gutter mt2 mt0-ns tc",
	      class: {
	        'ToggleThumbnail--selected': _vm.currentOptionIndex === optI,
	          'ToggleThumbnail--disabled': _vm.disabledOptions.includes(option.id)
	      }
	    }, [_c('div', {
	      staticClass: "cell w-100"
	    }, [_c('div', {
	      staticClass: "ToggleThumbnailBox",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.selectOption(option, optI)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "Thumbnail aspect-ratio aspect-ratio--1x1"
	    }, [_c('div', {
	      staticClass: "aspect-ratio--object cover",
	      style: (_vm.thumbnails[optI])
	    })]), _c('div', {
	      staticClass: "ToggleThumbnailInfos ph2 pv3 ph3-l pv3-l"
	    }, [_c('div', {
	      staticClass: "ToggleThumbnailName"
	    }, [_vm._v(_vm._s(_vm._f("ratio")(option.name)))])])]), (option.description) ? _c('div', {
	      staticClass: "ToggleThumbnailInfos pt1 pt2-l pb3"
	    }, [_c('div', {
	      staticClass: "ToggleThumbnailDescription",
	      domProps: {
	        "innerHTML": _vm._s(option.description)
	      }
	    })]) : _vm._e()])]) : _vm._e()
	  }), 0), (_vm.selectedOption.customField) ? _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.selectedOption.customFieldData),
	      expression: "selectedOption.customFieldData",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    attrs: {
	      "placeholder": _vm.selectedOption.description
	    },
	    domProps: {
	      "value": (_vm.selectedOption.customFieldData)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.selectedOption, "customFieldData", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), (!_vm.areAllOptionsDisabled && _vm.isCurrentOptionDisabled) ? _c('p', {
	    staticClass: "f6 lh-copy measure ToggleError dark-red"
	  }, [_vm._v("Please select an available option")]) : _vm._e(), (_vm.isCustomFieldEmpty) ? _c('p', {
	    staticClass: "f6 lh-copy measure ToggleError dark-red"
	  }, [_vm._v("Please enter a description")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "BookartSubmit pa2-m pa4-l"
	  }, [_c('form', {
	    ref: "form",
	    staticClass: "mw7-ns center",
	    attrs: {
	      "method": "POST",
	      "enctype": "multipart/form-data",
	      "action": ((_vm.$root.BASE) + "/api/v1/submit")
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.submitForm($event)
	      }
	    }
	  }, [_c('h3', [_vm._v("Submit your project")]), _c('p', {
	    staticStyle: {
	      "line-height": "1.5"
	    }
	  }, [_vm._v("This estimator is intended to provide you with a rough cost estimate. Once you submit your estimate, BookArt will contact you to discuss your project in more detail and provide you with a final quote.")]), _c('p', {
	    staticClass: "small mb4"
	  }, [_vm._v("* Indicates a required field.")]), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "HTMLSummary"
	    },
	    domProps: {
	      "value": _vm.HTMLSummary
	    }
	  }), _c('div', {
	    staticClass: "cf mb3"
	  }, [_c('div', {
	    staticClass: "fl w-50 pr2"
	  }, [_c('label', {
	    attrs: {
	      "for": "firstname"
	    }
	  }, [_vm._v("First name *")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.model.firstname),
	      expression: "model.firstname",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    attrs: {
	      "type": "text",
	      "name": "firstname"
	    },
	    domProps: {
	      "value": (_vm.model.firstname)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "firstname", $event.target.value.trim())
	      }, function($event) {
	        return _vm.$v.model.firstname.$touch()
	      }],
	      "focusout": function($event) {
	        return _vm.$v.model.firstname.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), (_vm.$v.model.firstname.$error && !_vm.$v.model.firstname.required) ? _c('div', {
	    staticClass: "red f6 mt2"
	  }, [_vm._v("Required")]) : _vm._e()]), _c('div', {
	    staticClass: "fl w-50 pl2"
	  }, [_c('label', {
	    attrs: {
	      "for": "lastname"
	    }
	  }, [_vm._v("Last name *")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.model.lastname),
	      expression: "model.lastname",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    attrs: {
	      "type": "text",
	      "name": "lastname"
	    },
	    domProps: {
	      "value": (_vm.model.lastname)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "lastname", $event.target.value.trim())
	      }, function($event) {
	        return _vm.$v.model.lastname.$touch()
	      }],
	      "focusout": function($event) {
	        return _vm.$v.model.lastname.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), (_vm.$v.model.lastname.$error && !_vm.$v.model.lastname.required) ? _c('div', {
	    staticClass: "red f6 mt2"
	  }, [_vm._v("Required")]) : _vm._e()])]), _c('div', {
	    staticClass: "mb3"
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email *")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.model.email),
	      expression: "model.email",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticStyle: {
	      "max-width": "376px"
	    },
	    attrs: {
	      "type": "email",
	      "name": "email"
	    },
	    domProps: {
	      "value": (_vm.model.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "email", $event.target.value.trim())
	      }, function($event) {
	        return _vm.$v.model.email.$touch()
	      }],
	      "focusout": function($event) {
	        return _vm.$v.model.email.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), (_vm.$v.model.email.$error && !_vm.$v.model.email.required) ? _c('div', {
	    staticClass: "red f6 mt2"
	  }, [_vm._v("Required")]) : _vm._e(), (_vm.$v.model.email.$error && _vm.$v.model.email.required && !_vm.$v.model.email.email) ? _c('div', {
	    staticClass: "red f6 mt2"
	  }, [_vm._v("Please enter a valid email")]) : _vm._e()]), _c('div', {
	    staticClass: "mb4"
	  }, [_c('label', {
	    attrs: {
	      "for": "postal"
	    }
	  }, [_vm._v("Postal code")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.model.postal),
	      expression: "model.postal",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticStyle: {
	      "max-width": "127px"
	    },
	    attrs: {
	      "type": "text",
	      "name": "postal"
	    },
	    domProps: {
	      "value": (_vm.model.postal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "postal", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _c('div', {
	    staticClass: "mb4"
	  }, [_c('h3', {
	    staticClass: "mb0"
	  }, [_vm._v("Deadline")]), _c('p', {
	    staticClass: "f6 lh-copy measure gray mt1"
	  }, [_vm._v("Please select a project deadline—the date by which you wish to receive the books. Once we have received your submission, we will look over the project details and provide you with a timeline for book production.")]), _c('datepicker', {
	    attrs: {
	      "name": "deadline",
	      "disabled": _vm.disabledDates,
	      "inline": true
	    },
	    model: {
	      value: (_vm.model.deadline),
	      callback: function($$v) {
	        _vm.$set(_vm.model, "deadline", $$v)
	      },
	      expression: "model.deadline"
	    }
	  })], 1), (_vm.settings.showDesignFilesUpload) ? _c('div', {
	    staticClass: "mb4"
	  }, [_c('h3', {
	    staticClass: "mb0"
	  }, [_vm._v("Design Files")]), _c('p', {
	    staticClass: "f6 lh-copy measure gray mt1"
	  }, [_vm._v("If you have your book already designed please provide a low-res PDF. This will help us provide the most accurate estimate. (File must be less than 25MB)")]), _c('input', {
	    ref: "filePicker",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "name": "filepicker",
	      "type": "file",
	      "multiple": "",
	      "accept": ".pdf"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.filePickerChange($event)
	      }
	    }
	  }), _c('a', {
	    staticClass: "dib f6 no-underline tc bg-near-black white bg-animate hover-bg-dark-gray pv3 ph4 ttu tracked",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openFilePicker.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("Upload PDFs")]), (_vm.designFiles.length > 0) ? _c('ul', {
	    staticClass: "Filelist"
	  }, _vm._l((_vm.designFiles), function(designFile) {
	    return _c('li', [_vm._v(_vm._s(designFile.filename) + " (" + _vm._s(designFile.size) + ")")])
	  }), 0) : _vm._e()]) : _vm._e(), _c('div', {
	    staticClass: "mb4"
	  }, [_c('h3', {
	    staticClass: "mb0"
	  }, [_vm._v("Copy edit required?")]), _c('p', {
	    staticClass: "f6 lh-copy measure gray mt1"
	  }, [_vm._v("Most book submissions contain more errors—often many more—than clients imagine. However, a solid copy edit can protect your credibility and enhance your text by ensuring consistency in regard to spelling, grammar, punctuation, style, page numbering, format issues, and more. Our team of professional copy editors can help.")]), _c('p', {
	    staticClass: "small mb4"
	  }, [_vm._v("* Billed separately.")]), _c('div', [_c('div', {
	    staticClass: "Radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.copyediting),
	      expression: "model.copyediting"
	    }],
	    attrs: {
	      "id": "copyediting-yes",
	      "type": "radio",
	      "name": "copyediting",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.model.copyediting, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.model, "copyediting", "1")
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "copyediting-yes"
	    }
	  }, [_vm._v("Yes")])]), _c('div', {
	    staticClass: "Radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.copyediting),
	      expression: "model.copyediting"
	    }],
	    attrs: {
	      "id": "copyediting-no",
	      "type": "radio",
	      "name": "copyediting",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.model.copyediting, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.model, "copyediting", "0")
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "copyediting-no"
	    }
	  }, [_vm._v("No")])])])]), _c('div', {
	    staticClass: "mb4"
	  }, [_c('h3', {
	    staticClass: "mb0"
	  }, [_vm._v("Graphic design assistance required?")]), _c('p', {
	    staticClass: "f6 lh-copy measure gray mt1"
	  }, [_vm._v("Attractive, consistent graphic design is a key component of a solid publication. We offer a full range of design services, from image editing, to typography and layout, to polishing your final book design. Let us help you enhance your graphics and tighten up your book’s overall look.")]), _c('p', {
	    staticClass: "small mb4"
	  }, [_vm._v("* Billed separately.")]), _c('div', [_c('div', {
	    staticClass: "Radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.designassistance),
	      expression: "model.designassistance"
	    }],
	    attrs: {
	      "id": "designassistance-yes",
	      "type": "radio",
	      "name": "designassistance",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.model.designassistance, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.model, "designassistance", "1")
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "designassistance-yes"
	    }
	  }, [_vm._v("Yes")])]), _c('div', {
	    staticClass: "Radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.designassistance),
	      expression: "model.designassistance"
	    }],
	    attrs: {
	      "id": "designassistance-no",
	      "type": "radio",
	      "name": "designassistance",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.model.designassistance, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.model, "designassistance", "0")
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "designassistance-no"
	    }
	  }, [_vm._v("No")])])])]), _c('div', {
	    staticClass: "mb4"
	  }, [_c('h3', {
	    staticClass: "mb0"
	  }, [_vm._v("Prepress assistance required?")]), _c('p', {
	    staticClass: "f6 lh-copy measure gray mt1"
	  }, [_vm._v("So, your book design is complete—but have you prepared the files for print? Bad prepress can result in formatting problems, color distortions, and other inconsistencies. Get the drop on these issues—let us set up your files for proper binding type, ensure the best possible color reproduction, and troubleshoot all your problems before the ink hits the paper.")]), _c('div', [_c('div', {
	    staticClass: "Radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.prepressassistance),
	      expression: "model.prepressassistance"
	    }],
	    attrs: {
	      "id": "prepressassistance-yes",
	      "type": "radio",
	      "name": "prepressassistance",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.model.prepressassistance, "1")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.model, "prepressassistance", "1")
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "prepressassistance-yes"
	    }
	  }, [_vm._v("Yes")])]), _c('div', {
	    staticClass: "Radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.prepressassistance),
	      expression: "model.prepressassistance"
	    }],
	    attrs: {
	      "id": "prepressassistance-no",
	      "type": "radio",
	      "name": "prepressassistance",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.model.prepressassistance, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.model, "prepressassistance", "0")
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "prepressassistance-no"
	    }
	  }, [_vm._v("No")])])])]), _c('div', {
	    staticClass: "mb4"
	  }, [_c('h3', {
	    staticClass: "mb0"
	  }, [_vm._v("Comments and requests")]), _c('p', {
	    staticClass: "f6 lh-copy measure gray mt1"
	  }, [_vm._v("Please tell us about custom requests or any other important information. This may include custom sizing, finishing techniques, specialty paper choices, or anything you think we ought to know about your book.")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model.comments),
	      expression: "model.comments"
	    }],
	    attrs: {
	      "name": "comments",
	      "rows": "5",
	      "placeholder": "Enter your comments and requests here"
	    },
	    domProps: {
	      "value": (_vm.model.comments)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.model, "comments", $event.target.value)
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "Quantities pa2-m pa4-l"
	  }, [_c('div', {
	    staticClass: "mw7-ns tl"
	  }, [_c('p', {
	    staticClass: "f4 mb5 lh-copy measure gray",
	    domProps: {
	      "innerHTML": _vm._s(_vm.settings.introductionText)
	    }
	  }), _c('h2', {
	    staticClass: "f4 f3-l"
	  }, [_vm._v("Quantity")]), _c('p', {
	    staticClass: "f5 lh-copy measure gray",
	    domProps: {
	      "innerHTML": _vm._s(_vm.settings.quantityBeforeText)
	    }
	  }), _c('div', {
	    staticClass: "pb2"
	  }, [_c('div', {
	    staticClass: "Box"
	  }, [_c('strong', {
	    staticClass: "BoxLabel"
	  }, [_vm._v("Number of books")]), _c('bookart-number', {
	    attrs: {
	      "min": 50,
	      "max": 5000,
	      "step": 1
	    },
	    model: {
	      value: (_vm.model.books),
	      callback: function($$v) {
	        _vm.$set(_vm.model, "books", $$v)
	      },
	      expression: "model.books"
	    }
	  })], 1), _c('div', {
	    staticClass: "Spacer"
	  }), _c('div', {
	    staticClass: "Box"
	  }, [_c('strong', {
	    staticClass: "BoxLabel"
	  }, [_vm._v("Number of pages")]), _c('bookart-number', {
	    attrs: {
	      "min": 4,
	      "max": 1024,
	      "step": 4
	    },
	    model: {
	      value: (_vm.model.pages),
	      callback: function($$v) {
	        _vm.$set(_vm.model, "pages", $$v)
	      },
	      expression: "model.pages"
	    }
	  })], 1)]), _c('p', {
	    staticClass: "f6 lh-copy measure gray pb2",
	    domProps: {
	      "innerHTML": _vm._s(_vm.settings.quantityAfterText)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "placeholder",
	    staticClass: "StickyPlaceholder",
	    class: {
	      "is-fixed": _vm.isFixed
	    },
	    style: (_vm.isFixed ? {
	      "height": (_vm.stickyContainerHeight + "px")
	    } : null)
	  }), _c('nav', {
	    ref: "nav",
	    staticClass: "Steps pa3-ns cf",
	    class: {
	      "is-fixed": _vm.isFixed
	    }
	  }, [(_vm.currentStepIndex > 0) ? _c('a', {
	    staticClass: "Nav fl ml3",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.currentStepIndex -= 1
	      }
	    }
	  }, [_c('span', {
	    staticClass: "NavArrow NavArrow--Left"
	  }, [_c('svg', {
	    attrs: {
	      "width": "10px",
	      "height": "6px",
	      "viewBox": "0 0 60 36",
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink"
	    }
	  }, [_c('g', {
	    attrs: {
	      "stroke": "none",
	      "stroke-width": "1",
	      "fill": "none",
	      "fill-rule": "evenodd"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M59.21875,31.203125 L31.875,1.20312 C31.61458,0.94271 31.32813,0.76042 31.01562,0.65625 C30.70312,0.55208 30.36459,0.5 30,0.5 C29.63541,0.5 29.29688,0.55208 28.98438,0.65625 C28.67187,0.76042 28.38542,0.94271 28.125,1.20312 L0.78125,31.203125 C0.2604141,31.671877 0,32.257809 0,32.960938 C0,33.664066 0.2604141,34.249998 0.78125,34.71875 C1.250002,35.2395859 1.835934,35.5 2.539062,35.5 C3.242191,35.5 3.828123,35.2395859 4.296875,34.71875 L30,6.59375 L55.70312,34.71875 C56.17188,35.2395859 56.75781,35.5 57.46094,35.5 C58.16407,35.5 58.75,35.2395859 59.21875,34.71875 C59.73959,34.249998 60,33.664066 60,32.960938 C60,32.257809 59.73959,31.671877 59.21875,31.203125 L59.21875,31.203125 Z",
	      "fill": "#000000"
	    }
	  })])])]), _vm._v("PREV")]) : _vm._e(), _c('ul', _vm._l((_vm.steps), function(step, i) {
	    return _c('li', {
	      class: {
	        active: i === _vm.currentStepIndex
	      }
	    }, [_c('a', {
	      staticClass: "Gotostep",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.currentStepIndex = i
	        }
	      }
	    }, [_c('span', {
	      staticClass: "StepNumber"
	    }, [_vm._v(_vm._s(i + 1))]), _c('span', {
	      staticClass: "StepText"
	    }, [_vm._v(_vm._s(step))])])])
	  }), 0), _c('a', {
	    staticClass: "Nav fr mr3",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.currentStepIndex += 1
	      }
	    }
	  }, [(_vm.currentStepIndex < _vm.steps.length - 1) ? _c('span', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.currentStepIndex += 1
	      }
	    }
	  }, [_vm._v("NEXT")]) : _c('span', {
	    staticClass: "submit",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.submitForm.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("SUBMIT")]), _c('span', {
	    staticClass: "NavArrow NavArrow--Right"
	  }, [_c('svg', {
	    attrs: {
	      "width": "10px",
	      "height": "6px",
	      "viewBox": "0 0 60 36",
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink"
	    }
	  }, [_c('g', {
	    attrs: {
	      "stroke": "none",
	      "stroke-width": "1",
	      "fill": "none",
	      "fill-rule": "evenodd"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M59.21875,31.203125 L31.875,1.20312 C31.61458,0.94271 31.32813,0.76042 31.01562,0.65625 C30.70312,0.55208 30.36459,0.5 30,0.5 C29.63541,0.5 29.29688,0.55208 28.98438,0.65625 C28.67187,0.76042 28.38542,0.94271 28.125,1.20312 L0.78125,31.203125 C0.2604141,31.671877 0,32.257809 0,32.960938 C0,33.664066 0.2604141,34.249998 0.78125,34.71875 C1.250002,35.2395859 1.835934,35.5 2.539062,35.5 C3.242191,35.5 3.828123,35.2395859 4.296875,34.71875 L30,6.59375 L55.70312,34.71875 C56.17188,35.2395859 56.75781,35.5 57.46094,35.5 C58.16407,35.5 58.75,35.2395859 59.21875,34.71875 C59.73959,34.249998 60,33.664066 60,32.960938 C60,32.257809 59.73959,31.671877 59.21875,31.203125 L59.21875,31.203125 Z",
	      "fill": "#000000"
	    }
	  })])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "top",
	    staticClass: "sans-serif",
	    class: {
	      'in-process': _vm.currentStepIndex >= 0 && _vm.currentStepIndex < _vm.steps.length
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('header', [_c('div', {
	    staticClass: "Topnav"
	  }, [_c('div', {
	    staticClass: "logo"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        _vm.currentStepIndex = 0
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(173),
	      "width": "100%"
	    }
	  })])]), _vm._m(0), _c('div', {
	    staticClass: "right-column"
	  })])]), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.currentStepIndex < 0) ? _c('section', {
	    key: "hero",
	    staticClass: "Hero black-90 ph3 mh-5 tc flex flex-column justify-center"
	  }, [_c('div', {
	    staticClass: "Hero-Space"
	  }, [_c('h1', {
	    staticClass: "mb4 mr4 ml4"
	  }, [_vm._v(_vm._s(_vm.settings.homeHeader))]), _vm._l((_vm.homeTextLines), function(homeText, idx) {
	    return _c('p', {
	      key: 'line' + idx,
	      staticClass: "mr4 ml4"
	    }, [_vm._v(_vm._s(homeText))])
	  }), _c('div', {
	    staticClass: "mt4 ml4 mr4"
	  }, [_c('a', {
	    staticClass: "BottomNavButton BottomNavButton--fluid",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.currentStepIndex = 0
	      }
	    }
	  }, [_vm._v("Get started")])])], 2)]) : _vm._e(), (_vm.currentStepIndex === _vm.steps.length) ? _c('section', {
	    key: "success",
	    staticClass: "Hero black-90 ph3 mh-5 tc flex flex-column justify-center"
	  }, [_c('div', {
	    staticClass: "Hero-Space center"
	  }, [_c('h1', {
	    staticClass: "f2 fw2 mb1"
	  }, [_vm._v(_vm._s(_vm.settings.submissionHeader))]), _c('h2', {
	    staticClass: "f6 f5-l fw4",
	    domProps: {
	      "innerHTML": _vm._s(_vm.settings.submissionText)
	    }
	  }), _c('div', {
	    staticClass: "mt5"
	  }, [_c('a', {
	    staticClass: "BottomNavButton BottomNavButton--fluid",
	    attrs: {
	      "href": "/"
	    }
	  }, [_vm._v("Make another estimate")])])])]) : _vm._e(), (_vm.currentStepIndex >= 0 && _vm.currentStepIndex < _vm.steps.length) ? _c('section', {
	    key: "process",
	    staticClass: "Process"
	  }, [_c('div', {
	    ref: "steps-top",
	    staticClass: "dn db-ns"
	  }), _c('bookart-steps', {
	    attrs: {
	      "steps": _vm.steps,
	      "disabled-options": _vm.disabledOptions
	    },
	    model: {
	      value: (_vm.currentStepIndex),
	      callback: function($$v) {
	        _vm.currentStepIndex = $$v
	      },
	      expression: "currentStepIndex"
	    }
	  }), _c('section', {
	    ref: "categories",
	    staticClass: "Categories ph3 ph5-l mb6 black-90"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('div', {
	    key: _vm.currentStepIndex
	  }, [(_vm.currentStepIndex === 0) ? _c('bookart-quantities', {
	    attrs: {
	      "settings": _vm.settings
	    },
	    model: {
	      value: (_vm.quantities),
	      callback: function($$v) {
	        _vm.quantities = $$v
	      },
	      expression: "quantities"
	    }
	  }) : _vm._e(), _vm._l((_vm.sections.general), function(catI) {
	    return (_vm.currentStepIndex === 0) ? _c('bookart-category', {
	      attrs: {
	        "selected-option-index": _vm.selectedOptions[catI]
	      },
	      on: {
	        "select": function($event) {
	          return _vm.selectOption(catI, $event)
	        }
	      },
	      model: {
	        value: (_vm.categories[catI]),
	        callback: function($$v) {
	          _vm.$set(_vm.categories, catI, $$v)
	        },
	        expression: "categories[catI]"
	      }
	    }) : _vm._e()
	  }), _vm._l((_vm.sections.cover), function(catI) {
	    return (_vm.currentStepIndex === 1 && !_vm.isCategoryIndexDisabled[catI]) ? _c('bookart-category', {
	      attrs: {
	        "selected-option-index": _vm.selectedOptions[catI]
	      },
	      on: {
	        "select": function($event) {
	          return _vm.selectOption(catI, $event)
	        }
	      },
	      model: {
	        value: (_vm.categories[catI]),
	        callback: function($$v) {
	          _vm.$set(_vm.categories, catI, $$v)
	        },
	        expression: "categories[catI]"
	      }
	    }) : _vm._e()
	  }), _vm._l((_vm.sections.paper), function(catI) {
	    return (_vm.currentStepIndex === 2 && !_vm.isCategoryIndexDisabled[catI]) ? _c('bookart-category', {
	      attrs: {
	        "selected-option-index": _vm.selectedOptions[catI]
	      },
	      on: {
	        "select": function($event) {
	          return _vm.selectOption(catI, $event)
	        }
	      },
	      model: {
	        value: (_vm.categories[catI]),
	        callback: function($$v) {
	          _vm.$set(_vm.categories, catI, $$v)
	        },
	        expression: "categories[catI]"
	      }
	    }) : _vm._e()
	  }), (_vm.currentStepIndex === 3) ? _c('bookart-review', {
	    attrs: {
	      "categories": _vm.categories,
	      "discounts": _vm.discounts,
	      "pageprices": _vm.pageprices,
	      "disabled-options": _vm.disabledOptions,
	      "quantities": _vm.quantities,
	      "selected-options": _vm.selectedOptions,
	      "groups": _vm.groups,
	      "settings": _vm.settings
	    }
	  }) : _vm._e(), (_vm.currentStepIndex === 4) ? _c('bookart-submit', {
	    ref: "submit",
	    attrs: {
	      "settings": _vm.settings
	    },
	    on: {
	      "success": _vm.success
	    },
	    model: {
	      value: (_vm.projectInfos),
	      callback: function($$v) {
	        _vm.projectInfos = $$v
	      },
	      expression: "projectInfos"
	    }
	  }) : _vm._e()], 2)]), _c('section', {
	    staticClass: "BottomNav pa2-m pa4-l mb5 m dn db-ns tc"
	  }, [(_vm.currentStepIndex > 0) ? _c('a', {
	    staticClass: "BottomNavButton BottomNavButton--empty",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.currentStepIndex -= 1
	      }
	    }
	  }, [_vm._v("Previous")]) : _vm._e(), (_vm.currentStepIndex < _vm.steps.length - 1) ? _c('a', {
	    staticClass: "BottomNavButton",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.currentStepIndex += 1
	      }
	    }
	  }, [_vm._v("Next")]) : _vm._e(), (_vm.currentStepIndex === _vm.steps.length - 1) ? _c('a', {
	    staticClass: "BottomNavButton BottomNavButton--submit",
	    class: {
	      'disabled': _vm.quantities.books < 50
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.submitForm.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("Submit")]) : _vm._e()])], 1), (_vm.quantities.books > 0) ? _c('bookart-summary', {
	    attrs: {
	      "categories": _vm.categories,
	      "disabled-options": _vm.disabledOptions,
	      "discounts": _vm.discounts,
	      "pageprices": _vm.pageprices,
	      "quantities": _vm.quantities,
	      "selected-options": _vm.selectedOptions,
	      "groups": _vm.groups,
	      "settings": _vm.settings
	    }
	  }) : _vm._e()], 1) : _vm._e()])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inner"
	  }, [_c('nav', [_c('div', {
	    staticClass: "nav-inner"
	  }, [_c('div', {
	    staticClass: "TopnavEl dn db-ns"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.bookart.ca/create-book/"
	    }
	  }, [_vm._v("Create Book")])]), _c('div', {
	    staticClass: "TopnavEl dn db-ns"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.bookart.ca/library/"
	    }
	  }, [_vm._v("Library")])]), _c('div', {
	    staticClass: "TopnavEl dn db-ns"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.bookart.ca/about/"
	    }
	  }, [_vm._v("About")])]), _c('div', {
	    staticClass: "TopnavEl dn db-ns"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.bookart.ca/shop/"
	    }
	  }, [_vm._v("Shop")])])])])])
	}]}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "Category pa2-m pa4-l"
	  }, [_c('header', {
	    staticClass: "Category-Header"
	  }, [_c('h2', {
	    staticClass: "f4 f3-l"
	  }, [_vm._v(_vm._s(_vm.model.name))]), _c('p', {
	    staticClass: "f5 lh-copy measure gray",
	    domProps: {
	      "innerHTML": _vm._s(_vm.model.description)
	    }
	  })]), _c('div', {
	    staticClass: "Category-Body"
	  }, [_c(_vm.componentType, {
	    tag: "component",
	    attrs: {
	      "selected-option-index": _vm.selectedOptionIndex
	    },
	    model: {
	      value: (_vm.model),
	      callback: function($$v) {
	        _vm.model = $$v
	      },
	      expression: "model"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "Review pa2-m pa4-l"
	  }, [_c('div', {
	    staticClass: "mw7-ns center"
	  }, [(_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "pv3"
	  }, [_vm._m(0)]) : _vm._e(), (_vm.quantities.books < 10) ? _c('div', {
	    staticClass: "pv3"
	  }, [_vm._m(1)]) : _c('div', [_c('div', {
	    staticClass: "flex flex-auto flex-wrap"
	  }, [_c('div', {
	    staticClass: "w-100 w-60-ns pa2 w-100-ns"
	  }, [_c('div', {
	    staticClass: "Box"
	  }, [_c('div', {
	    staticClass: "BoxQuantity"
	  }, [_vm._v(_vm._s(_vm.quantities.books))]), _c('div', {
	    staticClass: "BoxText"
	  }, [_vm._v("books")])])]), (_vm.showPrices) ? _c('div', {
	    staticClass: "w-100 w-40-ns pa2"
	  }, [_c('div', {
	    staticClass: "Box"
	  }, [_c('div', {
	    staticClass: "BoxQuantity green"
	  }, [_vm._v(_vm._s(_vm._f("price")(_vm.oneBookPrice)))]), _c('div', {
	    staticClass: "BoxText"
	  }, [_vm._v("per book (" + _vm._s(this.settings.currency) + ")")])])]) : _vm._e()]), _c('div', {
	    staticClass: "flex flex-auto flex-wrap mb4"
	  }, [_c('div', {
	    staticClass: "w-100 w-60-ns pa2 w-100-ns"
	  }, [_c('div', {
	    staticClass: "Box mb3"
	  }, [_c('div', {
	    staticClass: "BoxQuantity"
	  }, [_vm._v(_vm._s(_vm.quantities.pages))]), _c('div', {
	    staticClass: "BoxText"
	  }, [_vm._v("pages per book")])]), _c('div', {
	    staticClass: "Box"
	  }, [(_vm.discountPrice > 0) ? _c('div', {
	    staticClass: "BoxQuantity"
	  }, [_vm._v(_vm._s(_vm._f("price")(_vm.discountPrice)))]) : _vm._e(), (_vm.discountPrice > 0) ? _c('div', {
	    staticClass: "BoxText"
	  }, [_vm._v("Quantity discount")]) : _c('div', {
	    staticClass: "BoxText",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_vm._v("No quantity discount")])])]), (_vm.showPrices) ? _c('div', {
	    staticClass: "flex flex-auto flex-wrap w-100 w-40-ns pa2"
	  }, [_c('div', {
	    staticClass: "Box Box--total w-100"
	  }, [_c('div', {
	    staticClass: "BoxTotalPrice"
	  }, [_vm._v(_vm._s(_vm._f("price")(_vm.totalPrice)))]), _c('div', {
	    staticClass: "BoxText"
	  }, [_vm._v("Total price (" + _vm._s(this.settings.currency) + ")")])])]) : _vm._e()])]), _c('div', {
	    staticClass: "Section"
	  }, _vm._l((_vm.categoriesSummaries), function(categorySummary, catI) {
	    return (!_vm.isCategoryIndexDisabled[catI]) ? _c('div', {
	      staticClass: "Option flex justify-between items-center"
	    }, [_c('div', [_c('div', {
	      staticClass: "OptionCategory"
	    }, [_vm._v(_vm._s(categorySummary.category))])]), _c('div', [(_vm.invalidCategoriesIndexes.includes(catI)) ? _c('div', {
	      staticClass: "dark-red"
	    }, [_vm._v("Unavailable")]) : _c('span', [_vm._v(_vm._s(_vm._f("ratio")(categorySummary.name)))])])]) : _vm._e()
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "Box dark-red"
	  }, [_c('strong', [_vm._v("Error:")]), _vm._v(" One of your selected options is now unavailable."), _c('br', {
	    staticClass: "dn db-ns"
	  }), _vm._v("\nPlease review your choices below.\n")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "Box dark-red"
	  }, [_c('strong', [_vm._v("Error:")]), _vm._v(" You must choose a book quantity\nin order to proceed to making an estimate.\n")])
	}]}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "BookartNumber"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.internal),
	      expression: "internal",
	      modifiers: {
	        "number": true
	      }
	    }],
	    style: ({
	      width: _vm.width
	    }),
	    attrs: {
	      "type": "number",
	      "step": _vm.step,
	      "min": _vm.min,
	      "max": _vm.max
	    },
	    domProps: {
	      "value": (_vm.internal)
	    },
	    on: {
	      "blur": [_vm.onBlur, function($event) {
	        return _vm.$forceUpdate()
	      }],
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.internal = _vm._n($event.target.value)
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.model.options), function(option, optI) {
	    return (!_vm.disabledOptions.includes(option.id)) ? _c('a', {
	      staticClass: "Toggle",
	      class: {
	        'Toggle--selected': _vm.currentOptionIndex === optI,
	          'Toggle--disabled': _vm.disabledOptions.includes(option.id)
	      },
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.selectOption(option, optI)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "ToggleName"
	    }, [_vm._v(_vm._s(_vm._f("ratio")(option.name)))])]) : _vm._e()
	  }), (_vm.selectedOption.description && !_vm.areAllOptionsDisabled && !_vm.isCurrentOptionDisabled) ? _c('p', {
	    staticClass: "f6 lh-copy measure gray"
	  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ratio")(_vm.selectedOption.name)))]), _vm._v(": "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.selectedOption.description)
	    }
	  })]) : _vm._e(), (_vm.selectedOption.customField) ? _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.selectedOption.customFieldData),
	      expression: "selectedOption.customFieldData",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    attrs: {
	      "placeholder": _vm.selectedOption.description
	    },
	    domProps: {
	      "value": (_vm.selectedOption.customFieldData)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.selectedOption, "customFieldData", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), (!_vm.areAllOptionsDisabled && _vm.isCurrentOptionDisabled) ? _c('p', {
	    staticClass: "f6 lh-copy measure ToggleError dark-red"
	  }, [_vm._v("Please select an available option")]) : _vm._e(), (_vm.isCustomFieldEmpty) ? _c('p', {
	    staticClass: "f6 lh-copy measure ToggleError dark-red"
	  }, [_vm._v("Please enter a description")]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "Summary"
	  }, [_c('nav', {
	    staticClass: "SummaryBar"
	  }, [_c('div', {
	    staticClass: "flex justify-end"
	  }, [(_vm.showPrices && !_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "SummaryBarElement Price Per-Book"
	  }, [_c('div', {
	    staticClass: "price"
	  }, [_vm._v(_vm._s(_vm._f("price")(_vm.oneBookPrice)))]), _c('div', {
	    staticClass: "description"
	  }, [_vm._v("Per book")])]) : _vm._e(), (_vm.showPrices) ? _c('div', {
	    staticClass: "SummaryBarElement Price"
	  }, [(_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "price price--invalid"
	  }, [_vm._v("Calculating...")]) : _c('div', {
	    staticClass: "price"
	  }, [_vm._v(_vm._s(_vm._f("price")(_vm.totalPrice)))]), _c('div', {
	    staticClass: "description"
	  }, [_vm._v("Total (" + _vm._s(this.currency) + ")")])]) : _vm._e(), (_vm.showPrices && !this.settings.usdConversionRate == 0) ? _c('div', {
	    staticClass: "SummaryBarElement Currency"
	  }, [_c('span', {
	    class: {
	      current: this.settings.currency == "USD"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleCurrency("USD")
	      }
	    }
	  }, [_vm._v("USD")]), _c('span', [_vm._v(" | ")]), _c('span', {
	    class: {
	      current: this.settings.currency == "CAD"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleCurrency("CAD")
	      }
	    }
	  }, [_vm._v("CAD")])]) : _vm._e(), _c('div', {
	    ref: "button",
	    staticClass: "SummaryBarElement Toggler",
	    class: {
	      active: _vm.panelOpened
	    },
	    on: {
	      "click": _vm.togglePanel
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "10px",
	      "height": "6px",
	      "viewBox": "0 0 60 36",
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink"
	    }
	  }, [_c('g', {
	    attrs: {
	      "stroke": "none",
	      "stroke-width": "1",
	      "fill": "none",
	      "fill-rule": "evenodd"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M59.21875,31.203125 L31.875,1.20312 C31.61458,0.94271 31.32813,0.76042 31.01562,0.65625 C30.70312,0.55208 30.36459,0.5 30,0.5 C29.63541,0.5 29.29688,0.55208 28.98438,0.65625 C28.67187,0.76042 28.38542,0.94271 28.125,1.20312 L0.78125,31.203125 C0.2604141,31.671877 0,32.257809 0,32.960938 C0,33.664066 0.2604141,34.249998 0.78125,34.71875 C1.250002,35.2395859 1.835934,35.5 2.539062,35.5 C3.242191,35.5 3.828123,35.2395859 4.296875,34.71875 L30,6.59375 L55.70312,34.71875 C56.17188,35.2395859 56.75781,35.5 57.46094,35.5 C58.16407,35.5 58.75,35.2395859 59.21875,34.71875 C59.73959,34.249998 60,33.664066 60,32.960938 C60,32.257809 59.73959,31.671877 59.21875,31.203125 L59.21875,31.203125 Z",
	      "fill": "#000000"
	    }
	  })])]), _vm._v(" "), _c('span', [_vm._v("Summary")])])])]), _c('transition', {
	    attrs: {
	      "name": "slide-up"
	    }
	  }, [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.panelOpened),
	      expression: "panelOpened"
	    }],
	    ref: "panel",
	    staticClass: "SummaryPanel"
	  }, [_c('h3', {
	    staticClass: "SectionName"
	  }, [_vm._v("Summary")]), _c('table', {
	    attrs: {
	      "cellspacing": "0"
	    }
	  }, [_vm._l((_vm.categoriesSummaries), function(categorySummary, catI) {
	    return (!_vm.isCategoryIndexDisabled[catI]) ? _c('tr', [_c('td', [_c('p', {
	      staticClass: "b"
	    }, [_vm._v(_vm._s(categorySummary.category))])]), _c('td', [(_vm.invalidCategoriesIndexes.includes(catI)) ? _c('div', {
	      staticClass: "dark-red"
	    }, [_vm._v("Unavailable")]) : _c('span', [_vm._v(_vm._s(_vm._f("ratio")(categorySummary.name)))])])]) : _vm._e()
	  }), _c('tr', [_c('td', {
	    staticClass: "b pb3"
	  }, [_vm._v("Pages per book")]), _c('td', [_vm._v(_vm._s(_vm.quantities.pages))])]), _c('tr', [_c('td', {
	    staticClass: "b pb3"
	  }, [_vm._v("Number of books")]), _c('td', [_vm._v(_vm._s(_vm.quantities.books))])])], 2), (_vm.showPrices) ? _c('hr') : _vm._e(), (_vm.discountPrice > 0) ? _c('div', [_c('table', {
	    attrs: {
	      "cellspacing": "0"
	    }
	  }, [_c('tr', [_c('td', {
	    staticClass: "b pb3"
	  }, [_vm._v("Pre-total")]), _c('td', [(_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "dark-red"
	  }, [_vm._v("?")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.preTotalPrice)))])])])]), _c('table', {
	    attrs: {
	      "cellspacing": "0"
	    }
	  }, [_c('tr', [_c('td', {
	    staticClass: "b pb3"
	  }, [_vm._v("Quantity discount")]), _c('td', [(_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "dark-red"
	  }, [_vm._v("?")]) : _c('span', [_vm._v("- " + _vm._s(_vm._f("price")(_vm.discountPrice)))])])])])]) : _vm._e(), (_vm.showPrices) ? _c('table', {
	    attrs: {
	      "cellspacing": "0"
	    }
	  }, [_c('tr', [_c('td', {
	    staticClass: "b pb2"
	  }, [_vm._v("Total per book")]), _c('td', [(_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "dark-red"
	  }, [_vm._v("?")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.oneBookPrice)) + " " + _vm._s(_vm.currency))])])]), _c('tr', [_c('td', {
	    staticClass: "b pb2"
	  }, [_vm._v("Total")]), _c('td', {
	    staticClass: "b"
	  }, [(_vm.isTotalInvalid) ? _c('div', {
	    staticClass: "dark-red"
	  }, [_vm._v("?")]) : _c('span', [_vm._v(_vm._s(_vm._f("price")(_vm.totalPrice)) + " " + _vm._s(_vm.currency))])])])]) : _vm._e()])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.9987712ac079468ad002.js